<ng-container *ngIf="accommodation() && (checklistEcologe?.length || checklist?.length); else skeletonSort">
<div class="w-full flex items-center">
  <span class="me-3 w-24 text-sm font-semibold text-black-500">مرتب سازی :</span>

  <ng-container *ngIf="accommodation() != 'ecolodge';else hotelSort">
    <ul class="border rounded-lg flex items-center border-solid h-12 px-8 w-full justify-between">
      <li *ngFor="let item of checklist; let index = index" (click)="checkedItem(item.id,accommodation())"
        class="cursor-pointer {{item.isSelected ? 'border-b-2 py-2 border-blue-500 border-solid border-box' : ''}}">
        <span
          class="text-sm font-semibold {{item.isSelected ? 'text-black-500' : 'text-black-300'}}">{{item.value}}</span>
      </li>
    </ul>
  </ng-container>
  <ng-template #hotelSort>
    <ul *ngIf="accommodation() == 'ecolodge'"
      class="border rounded-lg flex items-center border-solid h-12 px-8 w-full gap-x-6 justify-start">
      <li *ngFor="let item of checklistEcologe; let index = index" (click)="checkedItem(item.id,accommodation())"
        class="cursor-pointer {{item.isSelected ? 'border-b-2 py-2 border-blue-500 border-solid border-box' : ''}}">
        <span
          class="text-sm font-semibold {{item.isSelected ? 'text-black-500' : 'text-black-300'}}">{{item.value}}</span>
      </li>
    </ul>
  </ng-template>
</div>
</ng-container>


<ng-template #skeletonSort>
<iho-skeleton width="100%" height="50px"></iho-skeleton>
  </ng-template>